import createIcon from '../../createIcon';

/**
 * @component @name Reviews
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMkg0QzIuOSAyIDIgMi45IDIgNFYyMkw2IDE4SDIwQzIxLjEgMTggMjIgMTcuMSAyMiAxNlY0QzIyIDIuOSAyMS4xIDIgMjAgMlpNMTMuNTcgMTEuNTdMMTIgMTVMMTAuNDMgMTEuNTdMNyAxMEwxMC40MyA4LjQzTDEyIDVMMTMuNTcgOC40M0wxNyAxMEwxMy41NyAxMS41N1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Reviews = createIcon('Reviews', [
  [
    'path',
    {
      d: 'M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM13.57 11.57L12 15L10.43 11.57L7 10L10.43 8.43L12 5L13.57 8.43L17 10L13.57 11.57Z',
      key: '17un0k',
    },
  ],
]);

export default Reviews;
